import { forwardRef, Ref, type SVGProps } from 'react';

const SvgPhotoIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <rect
      width={18}
      height={18}
      x={3}
      y={3}
      stroke="currentColor"
      strokeWidth={1.5}
      rx={4}
    />
    <circle cx={8.5} cy={8.5} r={1.5} stroke="currentColor" strokeWidth={1.5} />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m3 16 4.5-4.5a2 2 0 0 1 2.828 0L15 16m3-3-1.293-1.293a2 2 0 0 0-2.828 0L12.5 13"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgPhotoIcon);
export default ForwardRef;
